import React, { useState, useRef } from 'react';
import PartnerCarousel from './partnerCarousel';
import ServiceCard from './serviceCard';
import { servicesData } from "../json/servicesData";
import Footer from './footer';
import Header from './header';
import { useNavigate } from 'react-router-dom';

const Home = () => {

    const carouselRef = useRef<HTMLDivElement>(null);

    // Função para deslizar horizontalmente
    const scrollCarousel = (direction: "left" | "right") => {
        if (carouselRef.current) {
            const scrollAmount = 300; // Pixels a deslizar por clique
            if (direction === "left") {
                carouselRef.current.scrollBy({ left: -scrollAmount, behavior: "smooth" });
            } else {
                carouselRef.current.scrollBy({ left: scrollAmount, behavior: "smooth" });
            }
        }
    };

    const navigate = useNavigate();

    const handleNavigate = (path: string, id?: string) => {
        navigate(path);
        if (id) {
            setTimeout(() => {
                const element = document.getElementById(id);
                if (element) element.scrollIntoView({ behavior: 'smooth' });
            }, 100);
        }
    };

    return (
        <div className="flex flex-col w-[100%] h-[100%] dark:bg-maincodeSecondBlueDark dark:text-white">
            <div className="w-[100%] h-screen flex flex-col bg-gradient-to-br from-[#420C8D] to-[#615cb7] lg:bg-cover lg:bg-center lg:bg-no-repeat" style={{ backgroundImage: "url('Component 232 (1).png')" }}>
                <div className='pt-5 pl-3 h-[10%] lg:h-[20%] lg:flex lg:items-center'>
                    <Header />
                </div>
                <div className='flex flex-col w-[100%] h-[90%] lg:h-[80%] justify-center items-center md:flex-row md:p-3 lg:justify-start lg:w-[100%]'>
                    <div className='text-white flex flex-col w-[85%] lg:mt-3 lg:ml-16 lg:mb-3 md:w-[75%] md:p-3 lg:w-[45%] lg:p-6'>
                        <h1 className='text-2xl md:text-5xl lg:text-5xl'>
                            Comece um negócio com a contabilidade que a sua empresa merece!
                        </h1>
                        <p className='flex mt-5 mb-5 md:text-xl lg:mt-10 lg:mb-10 lg:text-2xl'>
                            Oferecemos soluções ágeis,
                            100% online e sem burocracia, para que você foque no que realmente importa: o
                            crescimento do seu negócio. <br /> Com tecnologia, transparência e suporte
                            especializado para manter tudo em dia, de forma prática e segura!
                        </p>
                        <button onClick={() => handleNavigate('/services', 'inicio')} className='bg-[#0F7022] p-3 rounded-lg lg:w-[45%] w-[75%] md:w-[45%] flex items-center justify-evenly'>
                            Conheça nossas soluções
                        </button>
                    </div>
                    {/* Imagem visível apenas em mobile */}
                    {/* <div className='lg:hidden w-[100%] flex justify-center mt-5 mb-10'>
                        <img src="image-01.png" alt="pc" className='w-[50%] md:w-[40%]' />
                    </div> */}
                </div>
            </div>

            <div className='flex flex-col items-center w-[100%] h-[100%]'>
                <div className=' bg-white flex flex-col w-[100%] p-6 lg:h-[33%] lg:pl-20 dark:bg-maincodeSecondBlueDark dark:text-white '>
                    <h1 className='text-2xl lg:text-4xl lg:mt-5'>
                        Descomplicando a sua contabilidade
                    </h1>
                    <p className='flex mt-3 mb-3 lg:text-2xl lg:mb-5'>
                        A Declarei Digital foi criada com o propósito de simplificar a gestão do seu negócio,
                        oferecendo serviços totalmente digitais, ágeis, transparentes e livres de burocracia.
                    </p>
                </div>
                <div className=' bg-[#0f7022b5] flex flex-col w-[100%] p-6 lg:h-[33%] lg:pl-20 dark:bg-[#5da0c491]  dark:text-white'>
                    <h1 className='text-2xl lg:text-4xl lg:mt-5'>
                        Há mais de 2 anos transformando sonhos em grandes negócios
                    </h1>
                    <p className='flex mt-3 mb-3 lg:text-2xl lg:mb-5'>
                        Auxiliamos empreendedores que estão iniciando do zero ou que buscam suporte para
                        impulsionar o crescimento de seus negócios.
                    </p>
                </div>
                <div className=' bg-[#0F7022] flex flex-col w-[100%] p-6 lg:pl-20 dark:bg-maincodeDarkBlueDark dark:text-white '>
                    <h1 className='text-2xl lg:text-4xl lg:mt-5'>
                        O controle financeiro ideal para sua empresa
                    </h1>
                    <p className='flex mt-3 mb-3 lg:text-2xl lg:mb-5'>
                        Otimizamos seu tempo e impulsionamos sua receita com um controle personalizado e
                        eficiente.
                    </p>
                </div>
            </div>
            <div className='flex flex-col p-3 h-[100%] w-[100%] dark:bg-[#5da0c491] '>
                <div className='flex w-[100%] text-center dark:text-white justify-center items-center lg:text-4xl text-2xl mb-3 lg:mb-5 lg:mt-10'>
                    <h2>Quem confia no nosso trabalho</h2>
                </div>
                <div className='lg:mb-5'>
                    <PartnerCarousel />
                </div>
            </div>
            <div className='flex lg:justify-end lg:items-center w-full min-h-screen lg:bg-cover lg:bg-center lg:bg-no-repeat'
                style={{ backgroundImage: "url('component 233.png')" }}>
                <div ref={carouselRef} className='flex lg:w-[48%] w-[100%] lg:p-0 py-5 my-2 justify-evenly items-start flex-wrap gap-10 overflow-x-hidden'>
                    {servicesData.services.map((service) => (
                        <div className="flex flex-col items-center">
                            <ServiceCard
                                key={service.serviceId}
                                title={service.title}
                                description={service.description}
                            />
                        </div>
                    ))}
                </div>

            </div>
            <div className='flex flex-col w-[100%] h-screen bg-white p-6 lg:items-center  dark:text-white'>
                <div className='flex flex-col w-[100%] h-[50%] text-center justify-center items-center md:mt-10 lg:mt-10'>
                    <h2 className='text-4xl font-medium mt-3 lg:text-6xl'>Empreendedorismo é o motor</h2>
                    <h2 className='text-4xl font-medium mb-5 lg:text-6xl'>que move o Brasil</h2>
                    <p className='lg:text-3xl lg:w-[70%] lg:mt-5'>Na Declarei Digital, estamos ao lado de nossos clientes em cada passo dessa jornada,
                        oferecendo soluções contábeis ágeis, simples e eficazes. Com nosso apoio, você pode
                        focar no crescimento do seu negócio, enquanto garantimos uma gestão contábil de
                        confiança e transparência.</p>
                </div>
                <div className='flex flex-col w-[100%] h-[50%] p-6 justify-center lg:flex-row lg:justify-evenly lg:w-[70%] lg:h-[30%] lg:flex-wrap lg:mt-5 md:flex-row md:justify-evenly md:w-[100%] md:h-[30%] md:flex-wrap md:mt-5'>
                    <div className='flex items-center mt-8 lg:mt-0 md:mt-0 mb-5 lg:text-2xl'>
                        <img src="marca 1.svg" alt="check icon" />
                        <p className='ml-3'>Suporte 24h</p>
                    </div>
                    <div className='flex items-center mb-5 lg:text-2xl'>
                        <img src="marca 1.svg" alt="check icon" />
                        <p className='ml-3'>Zero Burocracia</p>
                    </div>
                    <div className='flex items-center mb-5 lg:text-2xl'>
                        <img src="marca 1.svg" alt="check icon" />
                        <p className='ml-3'>Conformidade Fiscal</p>
                    </div>
                    <div className='flex items-center mb-5 lg:text-2xl'>
                        <img src="marca 1.svg" alt="check icon" />
                        <p className='ml-3'>Garantia de Qualidade</p>
                    </div>
                    <div className='flex items-center mb-5 lg:text-2xl'>
                        <img src="marca 1.svg" alt="check icon" />
                        <p className='ml-3'>Impostos Reduzidos</p>
                    </div>
                </div>
            </div>
            <div className='flex bg-[#001F40] flex-col text-white w-[100%] h-screen lg:flex-row-reverse lg:justify-evenly overflow-hidden'>
                <div className='flex flex-col w-[100%] md:w-[80%] lg:w-[50%] h-[100%] mt-3 mb-3 p-6 md:items-start md:text-start lg:justify-center lg:items-start lg:text-left lg:ml-5'>
                    <h1 className='text-2xl mb-5 md:text-4xl lg:text-6xl'>
                        Empreenda certo com a contabilidade certa
                    </h1>
                    <p className='flex mt-3 mb-8 md:w-[100%] md:text-lg lg:text-xl'>
                    O seu negócio merece uma contabilidade especializada. Entre em contato e decubra como podemos te ajudar!
                    </p>
                    <button onClick={() => handleNavigate('/services', 'inicio')} className='border border-1px border-white p-3 rounded-lg md:w-[35%] lg:w-[40%] w-[75%] flex items-center justify-evenly'>Conheça nossas soluções</button>
                </div>
                <div className='w-[50%] flex'>
                    <img src="icone grande declarei.svg" alt="pc" className='h-[220%] w-[200%] relative -top-[60%]  ' />
                </div>
            </div>
            <div className='flex w-[100%] h-[100%]'>
                <Footer />
            </div>
        </div>
    );
};

export default Home;